const html = document.querySelector('html');

export const modalBodyLock = () => {
    const ScrollTop =
        window.pageYOffset !== undefined
            ? window.pageYOffset
            : (
                  document.documentElement ||
                  document.body.parentNode ||
                  document.body
              ).scrollTop;
    html.classList.add('noscroll');
    html.style.top = `${-ScrollTop}px`;
    return ScrollTop;
};
export const modalBodyLockClear = (ScrollTop) => {
    html.classList.remove('noscroll');
    window.scrollTo(0, ScrollTop);
};
